import CountdownTimer from '../../components/base/CountdownTimer';
import WaitlistForm from '../../components/base/WaitlistForm';
import Orb from '../../components/base/Orb';
import FloatingHearts from '../../components/base/FloatingHearts';

export default function Home() {
  return (
    <div className="min-h-screen font-sans relative overflow-hidden bg-black">
      {/* Animated Orb Background */}
      <div className="absolute inset-0 z-0">
        <Orb hue={270} hoverIntensity={0.3} rotateOnHover={true} />
      </div>

      {/* Floating Hearts Background */}
      <FloatingHearts />

      {/* Content */}
      <div className="relative z-10 min-h-screen pointer-events-none">
        {/* Header */}
        <header className="w-full py-5 px-8 pointer-events-auto">
          <div className="container mx-auto flex justify-between items-center">
            <a href="#" className="text-2xl font-['Pacifico'] text-white">
              DollarStay
            </a>
            <div className="flex items-center gap-4">
              <button className="px-4 py-2 bg-white text-gray-900 text-sm rounded-full whitespace-nowrap hover:bg-gray-100 transition-all cursor-pointer">
                Get early access
              </button>
              <button className="w-10 h-10 flex items-center justify-center bg-white/10 backdrop-blur-sm border border-white/20 rounded-full cursor-pointer hover:bg-white/20 transition-all">
                <i className="ri-question-line text-white"></i>
              </button>
            </div>
          </div>
        </header>

        {/* Main Content */}
        <main className="container mx-auto px-8 flex items-center min-h-[80vh] pointer-events-auto">
          <div className="flex flex-col items-center text-center max-w-4xl mx-auto w-full">
            {/* Hero Title */}
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-8 tracking-tight text-white text-center max-w-[90%] xl:max-w-[80%] 2xl:max-w-[70%] mx-auto">
              DollarStay
            </h1>

            {/* Countdown Timer */}
            <div className="mb-8 w-full">
              <CountdownTimer />
              
              {/* People Joined Counter */}
              <div className="mb-6">
                <div className="flex items-center gap-2 text-gray-300 justify-center">
                  <i className="ri-user-follow-line"></i>
                  <span className="text-sm">1,234 people already joined</span>
                </div>
              </div>

              {/* Waitlist Form */}
              <WaitlistForm />
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}
